<div class="backgroundContainer"></div>
<app-header></app-header>
<simple-notifications [options]="notifyOptions"></simple-notifications>

<div class="contentContainer">
  <div class="container-fluid contentWrapper px-0">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
<router-outlet name="modal"></router-outlet>
